module.exports = __webpack_public_path__ + "static/media/4.69b97736.jpg";